import 'protons';
import './_video-gallery.scss';
import './_video-gallery.twig';
// import Plyr from 'plyr';
import $ from 'jquery';

export const name = 'video-gallery';

export const defaults = {};

export function disable() {}

const SHOW_CLASS = 'show';

const $backdrop = $('<div>')
  .addClass('video-gallery__backdrop')
  .hide()
  .appendTo(document.body);

export function enable(context) {
  $('.video-gallery__item', context).each((index, item) => {
    const $trigger = $(item);

    $trigger.on('click', () => {
      const container = $trigger.next('.video-gallery__video');
      // const $player = $('.video-gallery__player', container);
      const $close = $('.video-gallery__video-close', container);
      // const plyr = new Plyr($player.get(0), {
      //   controls: [
      //     'play',
      //     'play-large',
      //     'progress',
      //     'current-time',
      //     'mute',
      //     'volume',
      //     'settings',
      //     'fullscreen',
      //   ],
      // });

      const handleOnCloseClick = () => {
        $trigger.removeClass(SHOW_CLASS);
        $backdrop.hide();
        $close.off('click', handleOnCloseClick);
        // plyr.destroy();
      };

      $close.on('click', handleOnCloseClick);
      $trigger.addClass(SHOW_CLASS);
      $backdrop.show();
    });
  });
}

export default enable;
